export const ROUTES = {
    HOME: '/',
    ACCOUNT: '/mi-cuenta/datos',
    LOGIN: '/login',
    PRODUCT:'/product'
}